import DataViewQueryResultTableHeader from "./DataViewQueryResultTableHeader";
import DataViewQueryResultTableRow from "./DataViewQueryResultTableRow";
import _ from "lodash";
import React from "react";
import key from "weak-key";

interface Props {
  results: string[];
  onChange?: () => void;
  handleIdColumnSelect?: (arg0: string, arg1: string[], arg2: () => void) => void;
  selectedIdColumns?: string[];
  dataviewQueryDurationMs?: number;
  totalNumRows?: number;
  height?: string;
  columnsSelectable?: boolean;
  readOnly?: boolean;
}

export default function DataViewQueryResultTable({
  results,
  onChange,
  handleIdColumnSelect,
  selectedIdColumns,
  dataviewQueryDurationMs,
  totalNumRows,
  height,
  columnsSelectable,
  readOnly,
}: Props): JSX.Element {
  const columnNames = Object.keys(results[0]);
  return (
    <>
      <div className="flex flex-col h-full">
        <div className="">
          <div className="p-2 flex flex-row justify-between text-gray-600 text-sm w-full">
            <div className="mr-1 flex flex-col text-start">
              <span>Results are limited to 50 rows.</span>
              <span>Select columns that uniquely identify a row for triggering alerts.</span>
            </div>
            <div className="text-end">
              {dataviewQueryDurationMs ? <div>Query Duration: {(dataviewQueryDurationMs / 1000).toFixed(2)}s</div> : null}
              {totalNumRows ? <div>Total Number of Rows: {totalNumRows}</div> : null}
            </div>
          </div>
        </div>
        <div className={`${!height ? "h-full" : ""} overflow-scroll relative`} style={{ maxHeight: height }}>
          <table className="mb-5">
            <thead className="bg-gray-50 sticky top-0 shadow-md">
              <tr>
                {columnNames.map((columnName, index) => {
                  return (
                    <DataViewQueryResultTableHeader
                      key={key({ columnName })}
                      columnName={columnName}
                      index={index}
                      onChange={onChange}
                      selectedIdColumns={selectedIdColumns}
                      handleIdColumnSelect={handleIdColumnSelect}
                      columnsSelectable={!!columnsSelectable}
                      readOnly={readOnly}
                    />
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {results.map((row, index) => {
                return <DataViewQueryResultTableRow key={key({ row })} row={row} index={index} selectedIdColumns={selectedIdColumns as string[]} />;
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
